import fire from '@store/firebase';

import { CollectionPath } from '@typings/collections.enum';
import { deleteImgStorage } from '@store/firebase/storage';

const firestore = fire.firestore();
const bannerRef = firestore.collection(CollectionPath.BANNER);

export async function deleteBanner(imgURL, docId) {
  if (imgURL) deleteImgStorage(imgURL);
  return bannerRef.doc(docId).delete();
}

export async function deleteBannerImg(imgURL, docId) {
  if (imgURL) deleteImgStorage(imgURL);
  return bannerRef
    .doc(docId)
    .set({ imgURL: '' }, { merge: true })
    .catch((err) => alert(err.message));
}
